import React, { Component } from 'react';

export class AppFooter extends Component {

    render() {
        return (
            <div className="layout-footer clearfix">
                <a href="https://fromlabs.com">
                    <img alt="logo-colored" src={require('../../assets-public/images/logo/fl_solution_logo.png')}/>
                </a>
                <span className="footer-text-right">
                    <span className="material-icons">copyright</span>
                    <span> All Rights Reserved</span>
                </span>
            </div>
        );
    }
}
